import React from 'react';
import Section from "./Section.js";
import Link from "./Link";

export default props => {
  const Lang = props.lang.Links;
  return (
    <Section id="Links" header={Lang.header}>
      <Link url="http://birdsafe.ca/homes-safe-for-birds/" text={Lang.homes_safe_for_birds}/>
      <Link url="http://birdsafe.ca/workplaces-safe-for-birds/" text={Lang.workplaces_safe_for_birds}/>
      <Link url="https://birdmapper.org/app/" text={Lang.global_mapper}/>
      <Link url="https://birdmapper.org/" text={Lang.collision_count_week}/>
      <Link url="https://birdsafe.ca/birdsafe-consulting-service/" text={Lang.birdsafe_consulting_serice}/>
      <Link url="https://birdsafe.ca/contact/" text={Lang.contact_flap_canada}/>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Links.js